/* Spruce reference pages — reveal, count-up, bars, sticky nav highlight */
(function () {
  function init() {
    var root = document.querySelector('.srf');
    if (!root) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- scroll reveal + one-shot triggers ---- */
    var reveals = root.querySelectorAll('.srf-reveal');
    if (!('IntersectionObserver' in window) || reduce) {
      Array.prototype.forEach.call(reveals, function (el) { el.classList.add('is-in'); });
      runCounts(root.querySelectorAll('[data-count-to]'), true);
      fillBars(root.querySelectorAll('.srf-bar__fill'));
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(reveals, function (el) { io.observe(el); });

    /* ---- count ups ---- */
    var counters = root.querySelectorAll('[data-count-to]');
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        runCounts([entry.target], false);
        cio.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    Array.prototype.forEach.call(counters, function (el) { cio.observe(el); });

    /* ---- bars ---- */
    var bars = root.querySelectorAll('.srf-bar__fill');
    var bio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        fillBars([entry.target]);
        bio.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(bars, function (el) { bio.observe(el); });

    /* ---- sticky nav active state ---- */
    var links = root.querySelectorAll('.srf-nav a[href^="#"]');
    if (links.length) {
      var map = {};
      Array.prototype.forEach.call(links, function (a) {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (target) map[target.id] = a;
      });
      var nio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          Array.prototype.forEach.call(links, function (a) { a.classList.remove('is-active'); });
          if (map[entry.target.id]) map[entry.target.id].classList.add('is-active');
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      Object.keys(map).forEach(function (id) {
        var el = document.getElementById(id);
        if (el) nio.observe(el);
      });
    }
  }

  function fillBars(list) {
    Array.prototype.forEach.call(list, function (el) {
      el.style.setProperty('--fill', (el.getAttribute('data-fill') || '0') + '%');
    });
  }

  function runCounts(list, instant) {
    Array.prototype.forEach.call(list, function (el) {
      var to = parseFloat(el.getAttribute('data-count-to'));
      if (isNaN(to)) return;
      var suffix = el.getAttribute('data-count-suffix') || '';
      if (instant) { el.textContent = to + suffix; return; }
      var start = null;
      var dur = 1400;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
